//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PartnersSlider from './PartnersSlider.vue';

export default {
  components: {
    PartnersSlider,
  },
  data() {
    return {
      partners: [
        require('@/assets/svg/partners/partners-1.svg'),
        require('@/assets/svg/partners/partners-2.svg'),
        require('@/assets/svg/partners/partners-3.svg'),
        require('@/assets/svg/partners/partners-4.svg'),
        require('@/assets/svg/partners/partners-5.svg'),
        require('@/assets/svg/partners/partners-6.svg'),
        require('@/assets/svg/partners/partners-7.svg'),
        require('@/assets/svg/partners/partners-8.svg'),
        require('@/assets/svg/partners/partners-9.svg'),
        require('@/assets/svg/partners/partners-10.svg'),
        require('@/assets/svg/partners/partners-11.svg'),
        require('@/assets/svg/partners/partners-12.svg'),
        require('@/assets/svg/partners/partners-13.svg'),
        require('@/assets/svg/partners/partners-14.svg'),
        require('@/assets/svg/partners/partners-15.svg'),
        require('@/assets/svg/partners/partners-16.svg'),
        require('@/assets/svg/partners/partners-17.svg'),
        require('@/assets/svg/partners/partners-18.svg'),
        require('@/assets/svg/partners/partners-19.svg'),
        require('@/assets/svg/partners/partners-21.svg'),
        require('@/assets/svg/partners/partners-22.svg'),
        require('@/assets/svg/partners/partners-23.svg'),
        require('@/assets/svg/partners/partners-24.svg'),
      ],
    };
  },
};
